import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../hooks/useLanguage';
import { WhatsAppIcon } from './WhatsAppIcon';
export function FinalCTA() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      title: 'Book your Ibiza transfer in minutes',
      text: 'Send your route, date and passenger details on WhatsApp and get your fixed quote fast.',
      primaryCta: 'Get your price on WhatsApp',
      subcopy: 'No upfront payment · Instant reply · Fixed price'
    },
    es: {
      title: 'Reserva tu traslado en Ibiza en minutos',
      text: 'Envía tu ruta, fecha y datos de pasajeros por WhatsApp y recibe tu presupuesto fijo rápido.',
      primaryCta: 'Tu precio por WhatsApp',
      subcopy: 'Sin pago previo · Respuesta inmediata · Precio fijo'
    }
  };
  const {
    title,
    text,
    primaryCta,
    subcopy
  } = content[language];
  const whatsappUrl = language === 'en' ? 'https://wa.me/34613756211?text=Hello%2C%20I%20need%20a%20transfer%20in%20Ibiza.%0APickup%3A%0ADestination%3A%0ADate%3A%0ATime%3A%0APassengers%3A' : 'https://wa.me/34613756211?text=Hola%2C%20necesito%20un%20transfer%20en%20Ibiza.%0ARecogida%3A%0ADestino%3A%0AFecha%3A%0AHora%3A%0APasajeros%3A';
  return <section className="py-16 md:py-28 bg-navy relative overflow-hidden" data-id="element-36">
      <div className="relative mx-auto max-w-3xl px-5 text-center" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} data-id="element-38">
          <h2 className="text-3xl md:text-5xl font-heading text-white mb-5 md:mb-6 leading-tight" data-id="element-39">
            {title}
          </h2>
          <p className="text-base md:text-lg text-white/70 mb-8 md:mb-12 max-w-xl mx-auto leading-relaxed" data-id="element-40">
            {text}
          </p>

          <div className="flex flex-col items-center justify-center gap-4" data-id="element-41">
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center space-x-2.5 bg-whatsapp hover:bg-whatsapp-hover text-white px-8 py-4 rounded-full font-semibold transition-all text-base tracking-wide shadow-lg shadow-whatsapp/20" data-id="element-42">
              <WhatsAppIcon className="w-5 h-5" data-id="element-43" />
              <span data-id="element-44">{primaryCta}</span>
            </a>

            <p className="text-white/60 text-sm tracking-wide mt-2" data-id="element-45">
              {subcopy}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}